import React, { useState, useEffect } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, MenuItem, Alert, CircularProgress, Grid } from '@mui/material';
import { Add as AddIcon, Refresh as RefreshIcon, Delete as DeleteIcon } from '@mui/icons-material';
import ModuleHub from '../components/ModuleHub';
import { getCostCenters, createCostCenter, deleteCostCenter } from '../../../services/api';

const CostCenters = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [form, setForm] = useState({ code: '', name: '', type: 'department' });

  useEffect(() => { loadData(); }, []);
  const loadData = async () => {
    try { setLoading(true); const r = await getCostCenters(); setItems(r.data || []); }
    catch (err) { setError(err.message); } finally { setLoading(false); }
  };

  return (
    <ModuleHub moduleId="general-ledger" showFeatures={false}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 2 }}>
        <Button startIcon={<RefreshIcon />} onClick={loadData}>Refresh</Button>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setDialogOpen(true)}>Add Cost Center</Button>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {loading ? <CircularProgress /> : (
        <TableContainer component={Paper}><Table>
          <TableHead><TableRow><TableCell>Code</TableCell><TableCell>Name</TableCell><TableCell>Type</TableCell><TableCell>Actions</TableCell></TableRow></TableHead>
          <TableBody>{items.map(c => (
            <TableRow key={c.id}><TableCell><strong>{c.code}</strong></TableCell><TableCell>{c.name}</TableCell>
              <TableCell><Chip label={c.type} size="small" /></TableCell>
              <TableCell><Button size="small" color="error" startIcon={<DeleteIcon />} onClick={() => deleteCostCenter(c.id).then(loadData)}>Delete</Button></TableCell>
            </TableRow>
          ))}</TableBody>
        </Table></TableContainer>
      )}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>New Cost Center</DialogTitle>
        <DialogContent><Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={6}><TextField fullWidth label="Code" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} /></Grid>
          <Grid item xs={6}><TextField fullWidth select label="Type" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>{['department', 'project', 'profit_center'].map(t => <MenuItem key={t} value={t}>{t}</MenuItem>)}</TextField></Grid>
          <Grid item xs={12}><TextField fullWidth label="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></Grid>
        </Grid></DialogContent>
        <DialogActions><Button onClick={() => setDialogOpen(false)}>Cancel</Button><Button variant="contained" onClick={async () => { await createCostCenter(form); setDialogOpen(false); loadData(); }}>Save</Button></DialogActions>
      </Dialog>
    </ModuleHub>
  );
};

export default CostCenters;
